import type { ReactNode } from 'react'
import { useState } from 'react'
import { ChevronDownIcon } from '@/shared/ui/icons/ChevronDownIcon'
import { ChevronUpIcon } from '@/shared/ui/icons/ChevronUpIcon'
import { MoneyIcon } from '@/shared/ui/icons/MoneyIcon'
import { GiveHeartIcon } from '@/shared/ui/icons/GiveHeartIcon'
import { UserIcon } from '@/shared/ui/icons/UserIcon'
import { LocationPinIcon } from '@/shared/ui/icons/LocationPinIcon'

export function SupportInfoPanel({
  resourceChips,
  targetChips,
  region,
  cost,
  className = '',
}: {
  resourceChips: string[]
  targetChips: string[]
  region: string
  cost: string
  className?: string
}) {
  const [openResource, setOpenResource] = useState(false)
  const [openTarget, setOpenTarget] = useState(false)

  return (
    <section className={`flex flex-col gap-4 ${className}`}>
      <h2 className="m-0 text-body-sm font-semibold text-black-800">지원 정보</h2>
      <div className="flex flex-col gap-[23px]">
        <ChipRow
          icon={<GiveHeartIcon size={22} />}
          label="제공 서비스"
          chips={resourceChips}
          open={openResource}
          onToggle={() => setOpenResource((prev) => !prev)}
        />
        <ChipRow
          icon={<UserIcon size={22} />}
          label="해결 대상"
          chips={targetChips}
          open={openTarget}
          onToggle={() => setOpenTarget((prev) => !prev)}
        />
        <ValueRow icon={<LocationPinIcon size={22} />} label="지역" value={region} />
        <ValueRow icon={<MoneyIcon size={22} />} label="비용" value={cost} />
      </div>
    </section>
  )
}

function ChipRow({
  icon,
  label,
  chips,
  open,
  onToggle,
}: {
  icon: ReactNode
  label: string
  chips: string[]
  open: boolean
  onToggle: () => void
}) {
  if (chips.length === 0) return null
  return (
    <div className="flex items-start gap-2">
      <span className="flex shrink-0 items-center gap-1 pt-1.5 text-body-sm font-medium text-black-100">
        <span className="text-black-100">{icon}</span>
        {label}
      </span>
      <div className="flex min-w-px flex-1 flex-col items-end gap-2.5">
        <button
          type="button"
          className="flex cursor-pointer items-center gap-1.5 rounded-xl border-0 bg-transparent py-1.5 text-body-md font-semibold text-black-300"
          onClick={onToggle}
          aria-expanded={open}
        >
          {chips.length}개
          {open ? <ChevronUpIcon size={22} /> : <ChevronDownIcon size={22} />}
        </button>
        {open && (
          <div className="flex flex-wrap items-start justify-end gap-2.5">
            {chips.map((chip) => (
              <span
                key={chip}
                className="inline-flex min-w-16 shrink-0 items-center justify-center rounded-lg bg-violet-100 px-3 py-[3px] text-body-sm font-medium whitespace-nowrap text-violet-700"
              >
                {chip}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

function ValueRow({
  icon,
  label,
  value,
}: {
  icon: ReactNode
  label: string
  value: string
}) {
  if (value.length === 0) return null
  return (
    <div className="flex items-start gap-2">
      <span className="flex shrink-0 items-center gap-1 pt-1.5 text-body-sm font-medium text-black-100">
        <span className="text-black-100">{icon}</span>
        {label}
      </span>
      <span className="min-w-px flex-1 pt-1.5 text-right text-body-md font-semibold text-black-300">
        {value}
      </span>
    </div>
  )
}
